import React from 'react';
import "./Heading.scss"

const Heading = ({title}) => {
  return (
      <div className="heading">{title}</div>
  )
}

export default Heading
